import type { ReactNode } from "react";
import { MdsLink } from "@/mds/components/link";

export function buildRecordingInProgressToastContent(
  noteTitle: string,
  onNavigateToNote: () => void
): ReactNode {
  return (
    <div>
      {`Audio is being captured on note `}
      <MdsLink onClick={onNavigateToNote}>{noteTitle}</MdsLink>
      {`. Please stop recording before closing the app.`}
    </div>
  );
}
